import React from 'react';
import { Link } from 'react-router-dom';

const footerSections = [
  {
    title: 'Company',
    links: [
      { to: '/about-us', label: 'About Us' },
      { to: '/contact', label: 'Contact' },
      { to: '/careers', label: 'Careers' },
    ],
  },
  {
    title: 'Information',
    links: [
      { to: '/privacy-policy', label: 'Privacy Policy' },
      { to: '/terms-of-service', label: 'Terms of Service' },
      { to: '/cookie-policy', label: 'Cookie Policy' },
    ],
  },
  {
    title: 'Help',
    links: [
      { to: '/faqs', label: 'FAQs' },
      { to: '/trading-resources', label: 'Trading Resources' },
      { to: '/session-schedule', label: 'Session Schedule' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/disclaimer', label: 'Disclaimer' },
      { to: '/legal-notice', label: 'Legal Notice' },
      { to: '/dmca-notice', label: 'DMCA Notice' },
    ],
  },
];

function FooterSection() {
  return (
    <footer className="footer-custom -mb-10">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-12">
        {footerSections.map((section, index) => (
          <div key={index}>
            <h4 className="text-btn-color font-bold mb-6 text-mobile-font md:text-sm">
              {section.title}
            </h4>
            <ul className="space-y-5">
              {section.links.map((link, linkIndex) => (
                <li key={linkIndex}>
                  <Link
                    to={link.to}
                    className="footer-link text-gray-300 hover:text-white text-mobile-font md:text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 justify-between items-center">
        <p className="flex text-gray-300 text-center justify-center md:justify-end mt-8 text-mobile-font">
          © 2024 &nbsp;
          <a
            href="https://finzaid.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-btn-color hover:btn-hover-color"
            aria-label="Visit finzaid.com"
          >
            finzaid.com
          </a>
          . All rights reserved.
        </p>

        <p className="flex text-gray-300 justify-center md:justify-end text-center mt-8 text-mobile-font">
          V 1.1.8
        </p>
      </div>
    </footer>
  );
}

export default FooterSection;
